<template>
  <section class="section-about-landing">
    <div class="u-center-text u-margin-bottom-big">
      <h2 class="heading-secondary">
        Who am I?
      </h2>
    </div>

    <div class="row">
      <div class="col-1-of-2">
        <div class="about__images">
          <img
            src="@/assets/imgs/headshot.webp"
            alt="About Robot"
            class="composition__photo composition__photo--p4 nohover"
          >
        </div>
      </div>
      <div class="col-1-of-2">
        <h3 class="heading-tertiary u-margin-top-medium u-margin-bottom-small" /> 

        <h3 class="heading-tertiary u-margin-top-medium u-margin-bottom-small">
          Background
        </h3>
       
        <p class="paragraph">
          Hey there! My name is Aaron Fletcher. I have always been fascinated with the role of technology and language in the medical setting. During my 10+ years of experience as a primary veterinary practitioner, I have had the opportunity to see first-hand how technology can be used to improve the quality of care for patients and the quality of life for the veterinary team. This website will hopefully reflect my journey through Sheffield's CDT Speech and Language Technology program and my incoherent ramblings about any potential applications in veterinary medicine.  
        </p>
        <h3 class="heading-tertiary u-margin-top-medium u-margin-bottom-small">
          Research Interests
        </h3>
        <p class="paragraph">
          <ul>
            <li>Freeform, unstructured medical histories and text.</li>
            <li>Prediction of morbity and mortality from textual notes.</li>
            <li>Speech Pragmatics in a medical setting.</li>
          </ul>
        </p>

        <h3 class="heading-tertiary u-margin-top-medium u-margin-bottom-small">
          Some Links
        </h3>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutMe'
}
</script>
